import ui from '@/utils/ui'

const state = {
  fullscreen: false,
  spread: true,
  leftMenuOpen: false,
  zoom: false,
  spinner: false,
  hidePageElements: false
}

const getters = {
  fullscreen: state => state.fullscreen,
  spread: state => state.spread,
  leftMenuOpen: state => state.leftMenuOpen,
  zoom: state => state.zoom,
  spinner: state => state.spinner,
  hidePageElements: state => state.hidePageElements
}

const actions = {
  enterFullscreen ({ commit }) {
    ui.enterFullscreen(document.documentElement)
    commit('enterFullscreen')
  },
  exitFullscreen ({ commit }) {
    ui.exitFullscreen(document.documentElement)
    commit('exitFullscreen')
  },
  toggleSpread ({ commit }) {
    commit('toggleSpread')
  },
  setSpread ({ commit }, value) {
    commit('setSpread', value)
  },
  toggleLeftMenu ({ commit }) {
    commit('toggleLeftMenu')
  },
  toggleZoom ({ commit }) {
    commit('toggleZoom')
  },
  toggleSpinner ({ commit }) {
    commit('toggleSpinner')
  },
  toggleHidePageElements ({ commit, state }) {
    commit('setHidePageElements', !state.hidePageElements)
  }
}

const mutations = {
  enterFullscreen (state) {
    state.fullscreen = true
  },
  exitFullscreen (state) {
    state.fullscreen = false
  },
  toggleSpread (state) {
    state.spread = !state.spread
  },
  setSpread (state, value) {
    state.spread = value
  },
  toggleLeftMenu (state) {
    state.leftMenuOpen = !state.leftMenuOpen
  },
  toggleZoom (state) {
    state.zoom = !state.zoom
  },
  toggleSpinner (state) {
    state.spinner = !state.spinner
  },
  setHidePageElements (state, value) {
    state.hidePageElements = value
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
